import {
  EsgPlatformStatus,
  EsgProvidePercentLanguage,
} from 'src/Enum/EsgPlatform';

type EsgScoreStatusProps = {
  message: string;
  severity: 'success' | 'warning' | 'error' | 'info';
  language?: string;
};

export const checkEsgScoreStatus = (
  score: number | undefined,
  language?: string,
  hasPercent?: boolean
): EsgScoreStatusProps | undefined => {
  const esgPassPercent =
    Number(process.env.REACT_APP_ESG_PASS_SCORE_PERCENT) || 85;

  if (language === EsgProvidePercentLanguage.EN) {
    if (!hasPercent && score === null) {
      return {
        message: EsgPlatformStatus.NOT_FOUND_EN,
        severity: 'info',
      };
    }

    if (hasPercent && score === null) {
      return {
        message: EsgPlatformStatus.SERVER_ERROR,
        severity: 'error',
      };
    }
    if (score !== undefined && score >= esgPassPercent) {
      return {
        message: EsgPlatformStatus.SUCCESS,
        severity: 'success',
      };
    }
    if (score !== undefined && score < esgPassPercent) {
      return {
        message: EsgPlatformStatus.NOT_FOUND_EN,
        severity: 'info',
      };
    }
  }

  if (language === EsgProvidePercentLanguage.TH) {
    if (!hasPercent && score === null) {
      return {
        message: EsgPlatformStatus.NOT_FOUND_TH,
        severity: 'error',
      };
    }

    if (hasPercent && score === null) {
      return {
        message: EsgPlatformStatus.SERVER_ERROR,
        severity: 'error',
      };
    }

    if (score !== undefined && score >= esgPassPercent) {
      return {
        message: EsgPlatformStatus.SUCCESS,
        severity: 'success',
      };
    }

    if (score !== undefined && score < esgPassPercent) {
      return {
        message: EsgPlatformStatus.WARNING_BELOW_THRESHOLD,
        severity: 'error',
      };
    }
  }
  return undefined;
};
